export enum Icon {
  ACCOUNTING_COINS = 'accounting-coins',
  ACCOUNTING_DOCUMENT = 'accounting-document',
  ACCOUNTING_HUMAN_HIERARCHY = 'accounting-human-hierarchy',
  ADD = 'add',
  ALARM_BELL = 'alarm-bell',
  ALERT_CIRCLE = 'alert-circle',
  ALERT_TRIANGLE = 'alert-triangle',
  ALERT_TRIANGLE_2 = 'alert-triangle-2',
  ARCHIVE = 'archive',
  ARMCHAIR = 'armchair',
  ARROW_BACK = 'arrow-back',
  ARROW_BUTTON_LEFT_1 = 'arrow-button-left-1',
  ARROW_BUTTON_RIGHT_1 = 'arrow-button-right-1',
  ARROW_DOWN = 'arrow-down',
  ARROW_FORWARD = 'arrow-forward',
  ARROW_UP = 'arrow-up',
  ASSETS = 'assets',
  ASSIGNMENTS = 'assignments',
  ASTRONOMY_EARTH_ROTATION = 'astronomy-earth-rotation',
  BABY_BOY = 'baby-boy',
  BANK = 'bank',
  BOOK_FLIP_PAGE = 'book-flip-page',
  BREAKUP_COUPLE = 'breakup-couple',
  BUILDING_MODERN = 'building-modern',
  BUSINESS_CONTRACT_APPROVE = 'business-contract-approve',
  BUTTON_SPLIT = 'button-split',
  CALENDAR = 'calendar',
  CALENDAR_BLOCK = 'calendar-block',
  CALENDAR_CLOCK = 'calendar-clock',
  CAMERA_STUDIO = 'camera-studio',
  CAN = 'CAN',
  CAR = 'car',
  CAR_ACTIONS_SHIELD = 'car-actions-shield',
  CARET_DOWN = 'caret-down',
  CARET_LEFT = 'caret-left',
  CARET_RIGHT = 'caret-right',
  CARET_UP = 'caret-up',
  CASH_PAYMENT_BAG = 'cash-payment-bag',
  CASH_PAYMENT_BAG_1 = 'cash-payment-bag-1',
  CHANGELOG = 'changelog',
  CHAT_PLUS = 'chat-plus',
  CHAT_TRANSLATE = 'chat-translate',
  CHECK = 'check',
  CHECK_BADGE_ALTERNATE = 'check-badge-alternate',
  CHECK_CIRCLE_1 = 'check-circle-1',
  CHECK_CIRCLE_1_FILLED = 'check-circle-1-filled',
  CHECKLIST = 'checklist',
  CHECKLIST_1 = 'checklist-1',
  COG = 'cog',
  COG_DOUBLE = 'cog-double',
  COMMON_FILE_AWARD = 'common-file-award',
  COMMON_FILE_CHECK_AI = 'common-file-check-ai',
  COMMON_FILE_SETTINGS = 'common-file-settings',
  COMMON_FILE_TEXT_ALTERNATE = 'common-file-text-alternate',
  CONTACTS = 'contacts',
  CONTENT_PAPER_EDIT = 'content-paper-edit',
  CREDIT_CARD = 'credit-card',
  CREDIT_CARD_CHECK = 'credit-card-check',
  CRYPTO_CURRENCY_BITCOIN_INCREASE = 'crypto-currency-bitcoin-increase',
  CURRENCY_DOLLAR = 'currency-dollar',
  CURRENCY_DOLLAR_INCREASE = 'currency-dollar-increase',
  CURSOR = 'cursor',
  DASHBOARD = 'dashboard',
  DATABASE_CONNECTED = 'database-connected',
  DIAMOND_RING = 'diamond-ring',
  DIAMOND_RING_1 = 'diamond-ring-1',
  DIRECTION_BUTTON_SQUARE_ALTERNATE = 'direction-button-square-alternate',
  DISLIKE_1 = 'dislike-1',
  DISLIKE_LIGHT = 'dislike-light',
  DISTRIBUTION = 'distribution',
  DOCUMENTS = 'documents',
  DOCUMENTS_2 = 'documents-2',
  DOWNLOAD_BOTTOM = 'download-bottom',
  DUAL_SYNCHRONIZE_ARROWS_1 = 'dual-synchronize-arrows-1',
  DUPLICATE = 'duplicate',
  EARTH_LOCATE = 'earth-locate',
  EMAIL_UNREAD = 'email-unread',
  EXPAND = 'expand',
  EXPAND_2 = 'expand-2',
  EXPAND_4 = 'expand-4',
  EYE = 'eye',
  EYE_OFF = 'eye-off',
  FAMILY_HOME_1 = 'family-home-1',
  FILE_DOC = 'file-doc',
  FILE_PDF = 'file-pdf',
  FILE_XLS = 'file-xls',
  FILTER = 'filter',
  FLAG_1 = 'flag-1',
  FLASH_OFF = 'flash-off',
  FLASH_ON = 'flash-on',
  FLOWER = 'flower',
  FOLDER_MOVE = 'folder-move',
  FONT_SIZE = 'font-size',
  GIFT_BOX = 'gift-box',
  GRID = 'grid',
  HAND_EXPENDED = 'hand-expended',
  HASH = 'hash',
  HELP = 'help',
  HOUSE = 'house',
  HYPERLINK = 'hyperlink',
  INFORMATION_CIRCLE = 'information-circle',
  INSURANCE = 'insurance',
  KEYS = 'keys',
  LAUNCH = 'launch',
  LEGAL_CERTIFICATE = 'legal-certificate',
  LEGAL_HAMMER = 'legal-hammer',
  LEGAL_SCALE_UNEQUAL = 'legal-scale-unequal',
  LIGHT_BULB_SHINE = 'light-bulb-shine',
  LIGHT_BULB_SHINE_OPPORTUNITY = 'light-bulb-shine-opportunity',
  LIKE_1 = 'like-1',
  LIKE_LIGHT = 'like-light',
  LIST_BULLETS = 'list-bullets',
  LIST_NUMBERS = 'list-numbers',
  LOADING = 'loading',
  LOCK_1 = 'lock-1',
  LOCK_UNLOCK = 'lock-unlock',
  LOGOUT = 'logout',
  LOGOUT_1_ALTERNATE = 'logout-1-alternate',
  LOGOUT_REVERSE = 'logout-reverse',
  LOVE_IT_HAND_GIVE = 'love-it-hand-give',
  MAGIC_STARS = 'magic-stars',
  MAGIC_WAND = 'magic-wand',
  MAIL = 'mail',
  MAPS_PIN = 'maps-pin',
  MARKETPLACE = 'marketplace',
  MEGAPHONE = 'megaphone',
  MEMBERS = 'members',
  MENU = 'menu',
  MESSAGES = 'messages',
  MICROPHONE = 'microphone',
  MINUS = 'minus',
  MODERN_WEAPON_SHOTGUN = 'modern-weapon-shotgun',
  MONETIZATION_STRUCTURE = 'monetization-structure',
  MONEY_BAG_DOLLAR = 'money-bag-dollar',
  MOVE_DOWN = 'move-down',
  MOVE_LEFT = 'move-left',
  MOVE_LEFT_RIGHT = 'move-left-right',
  MOVE_RIGHT = 'move-right',
  MOVE_UP = 'move-up',
  MULTIPLE_ACTIONS_MONEY = 'multiple-actions-money',
  MULTIPLE_NEUTRAL = 'multiple-neutral',
  NAVIGATION_MENU_HORIZONTAL = 'navigation-menu-horizontal',
  NAVIGATION_MENU_VERTICAL = 'navigation-menu-vertical',
  NOTE_PIN = 'note-pin',
  OFFICE_SIGN_DOCUMENT = 'office-sign-document',
  OFFICIAL_BUILDING = 'official-building',
  OPPORTUNITIES = 'opportunities',
  PENCIL = 'pencil',
  PENCIL_WRITE_ALTERNATE = 'pencil-write-alternate',
  PEOPLE_MAN = 'people-man',
  PERCENT = 'percent',
  PERPLEXITY = 'perplexity',
  PET = 'pet',
  PHONE = 'phone',
  PHONE_ACTION_TEXT = 'phone-action-text',
  PICTURE_POLAROID_FRAME = 'picture-polaroid-frame',
  PICTURE_POLAROID_LANDSCAPE = 'picture-polaroid-landscape',
  PICTURE_POLAROID_LANDSCAPE_1 = 'picture-polaroid-landscape-1',
  PIN = 'pin',
  PIN_OFF = 'pin-off',
  PLUG = 'plug',
  PRINT_TEXT = 'print-text',
  QUESTION_BUBBLE = 'question-bubble',
  QUESTION_CIRCLE = 'question-circle',
  QUESTION_HELP_CIRCLE = 'question-help-circle',
  RATING_STAR = 'rating-star',
  READ_EMAIL_AT = 'read-email-at',
  REAL_ESTATE_BUILDING_HOUSE = 'real-estate-building-house',
  REFERRAL = 'referral',
  REMOVE = 'remove',
  REMOVE_CIRCLE = 'remove-circle',
  REMOVE_CIRCLE_INTERFACE_ESSENTIAL = 'remove-circle-interface-essential',
  REMOVE_SHIELD_INTERFACE_ESSENTIAL = 'remove-shield-interface-essential',
  REPORT = 'report',
  SAVING_BANK = 'saving-bank',
  SAVING_BANK_INTERNATIONAL = 'saving-bank-international',
  SAVING_PIGGY_DOLLARS = 'saving-piggy-dollars',
  SAVING_SAFE = 'saving-safe',
  SCREEN_ALTERNATE = 'screen-alternate',
  SEARCH = 'search',
  SEND_EMAIL = 'send-email',
  SEND_EMAIL_1 = 'send-email-1',
  SETTINGS_SLIDER = 'settings-slider',
  SHARE = 'share',
  SHARE_3_ALTERNATE = 'share-3-alternate',
  SHIELD_CHECK_1 = 'shield-check-1',
  SHIELD_CHECK_2 = 'shield-check-2',
  SHIELD_PERMISSION = 'shield-permission',
  SHRINK = 'shrink',
  SIGNAL_HIGH = 'signal-high',
  SIGNAL_LOW = 'signal-low',
  SIGNAL_MEDIUM = 'signal-medium',
  SINGLE_NEUTRAL_ACTIONS = 'single-neutral-actions',
  SINGLE_NEUTRAL_ACTIONS_ADD = 'single-neutral-actions-add',
  SINGLE_NEUTRAL_ACTIONS_FULL = 'single-neutral-actions-full',
  SINGLE_NEUTRAL_ACTIONS_MONEY = 'single-neutral-actions-money',
  SINGLE_NEUTRAL_BRIEFCASE = 'single-neutral-briefcase',
  SINGLE_NEUTRAL_ID_CARD_4 = 'single-neutral-id-card-4',
  SMILEY_DEVASTATED_1 = 'smiley-devastated-1',
  SOCIAL_FACEBOOK = 'social-facebook',
  SOCIAL_FACEBOOK_MESSENGER = 'social-facebook-messenger',
  SOCIAL_INSTAGRAM = 'social-instagram',
  SOCIAL_LINKEDIN = 'social-linkedin',
  SOCIAL_TWITTER = 'social-twitter',
  SOFA_DOUBLE = 'sofa-double',
  STAR = 'star',
  STARS = 'stars',
  SUBTRACT_CIRCLE = 'subtract-circle',
  SYNC_LOCATION = 'sync-location',
  SYNCHRONIZE_ARROW = 'synchronize-arrow',
  SYNCHRONIZE_ARROW_1 = 'synchronize-arrow-1',
  SYNCHRONIZE_ARROW_1_FILLED = 'synchronize-arrow-1-filled',
  SYNCHRONIZE_ARROW_CLOCK = 'synchronize-arrow-clock',
  TEAM = 'team',
  TEAM_CHAT = 'team-chat',
  TEAM_MEETING = 'team-meeting',
  TEAM_MONITOR_MEETING_1 = 'team-monitor-meeting-1',
  TEXT_BOLD = 'text-bold',
  TEXT_ITALIC = 'text-italic',
  TEXT_UNDERLINE = 'text-underline',
  THUMBNAIL = 'thumbnail',
  TIME_CLOCK_CIRCLE = 'time-clock-circle',
  TIME_CLOCK_CIRCLE_SOLID = 'time-clock-circle-solid',
  TOOLS_WRENCH_SCREWDRIVER = 'tools-wrench-screwdriver',
  TOUCH_ID = 'touch-id',
  TRASH = 'trash',
  TREND_DOWN = 'trend-down',
  TREND_UP = 'trend-up',
  TYPING_MACHINE = 'typing-machine',
  US = 'US',
  UNARCHIVE = 'unarchive',
  UPLOAD_BOTTOM = 'upload-bottom',
  UPLOAD_CIRCLE = 'upload-circle',
  ZOOM_IN = 'zoom-in',
  ZOOM_OUT = 'zoom-out'
}
